var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSoundoff01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m21.499 4-18 18-1.132-1.131 18-18z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.858 2.285a.8.8 0 0 1 .441.715v9.138l-1.6 1.6v-9.14L6.48 8.5a.8.8 0 0 1-.48.159H3.3v6.676h2.2a.8.8 0 0 1 .457.143l2.361 1.64-1.15 1.15-1.918-1.333h-2.75a.8.8 0 0 1-.8-.8V7.86a.8.8 0 0 1 .8-.8h3.234l6.287-4.7a.8.8 0 0 1 .838-.075M8.502 19.197l3.54 2.46A.8.8 0 0 0 13.3 21v-6.6L11.7 16v3.47l-2.047-1.423zm8.3-8.3a3.692 3.692 0 0 1-1.116 4.009l1.19 1.084a5.29 5.29 0 0 0 1.72-3.91c0-.864-.207-1.68-.575-2.402zm3.159-3.158a7.86 7.86 0 0 1 1.435 4.542 7.88 7.88 0 0 1-2.384 5.656l1.184 1.08a9.47 9.47 0 0 0 2.8-6.736 9.46 9.46 0 0 0-1.89-5.688zm.08-2.344L18.91 6.527a8 8 0 0 0-.204-.185l1.188-1.083q.075.067.147.136m-2.968 2.968-1.13 1.132a4 4 0 0 0-.35-.315l1.193-1.088q.15.13.287.271",
  clipRule: "evenodd"
})));
export default SvgIconSoundoff01;